module.exports = __webpack_public_path__ + "img/flow2.3a9b3e72.png";